/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A video's length; null for photos or when unreadable
 * @export
 * @interface DurationSeconds1
 */
export interface DurationSeconds1 {
}

/**
 * Check if a given object implements the DurationSeconds1 interface.
 */
export function instanceOfDurationSeconds1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DurationSeconds1FromJSON(json: any): DurationSeconds1 {
    return DurationSeconds1FromJSONTyped(json, false);
}

export function DurationSeconds1FromJSONTyped(json: any, ignoreDiscriminator: boolean): DurationSeconds1 {
    return json;
}

export function DurationSeconds1ToJSON(value?: DurationSeconds1 | null): any {
    return value;
}

